import React from 'react'

const ShieldIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 200, 255, 1)" />
          <stop offset="50%" stopColor="rgba(80, 160, 220, 1)" />
          <stop offset="100%" stopColor="rgba(60, 140, 200, 1)" />
        </linearGradient>
        <filter id="shieldGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Shield shape */}
      <path 
        d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4z"
        fill="url(#shieldGradient)"
        filter="url(#shieldGlow)"
      />
      
      {/* Check mark inside */}
      <path 
        d="M9 12l2 2 4-4"
        stroke="rgba(255, 255, 255, 0.9)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Shine effect */}
      <path 
        d="M8 6c2-1 4-1 6 0"
        stroke="rgba(255, 255, 255, 0.3)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ShieldIcon
